const getPlatform = () => {
  return process.env.VUE_APP_PLATFORM.toUpperCase();
};
export const platform = getPlatform();
